import { render, staticRenderFns } from "./fixedCashBack.vue?vue&type=template&id=478f289f&scoped=true&"
import script from "./fixedCashBack.vue?vue&type=script&lang=js&"
export * from "./fixedCashBack.vue?vue&type=script&lang=js&"
import style0 from "./fixedCashBack.vue?vue&type=style&index=0&id=478f289f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478f289f",
  null
  
)

export default component.exports